export default __webpack_public_path__ + "static/media/SndLowerPDiveDown.6009f843.mp3";